export function getOferte ({ state, commit }, { search, datefrom, dateto, page = 1}) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/oferte', { params: { search, datefrom, dateto, page } })
      .then((response) => {
        if (response.data.oferte) {
          commit('setOferte', response.data)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getOferta ({ state, commit }, ofertaId) {
  return new Promise((resolve, reject) => {
    if (ofertaId) {
      axiosInstance.get('/v1/oferte/' + ofertaId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta id'))
    }
  })
}

export function geteOriginalOferta ({ state, commit }, ofertaId) {
  return new Promise((resolve, reject) => {
    if (ofertaId) {
      axiosInstance.get('/v1/oferte/o/oferta/' + ofertaId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta eOriginal id'))
    }
  })
}

export function geteOriginalOfertaPDF ({ state, commit }, url) {
  return new Promise((resolve, reject) => {
    if (url) {
      axiosInstance.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa URL download pdf'))
    }
  })
}

export function getCreateOferta ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/oferte/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createOferta ({ state, commit }, { name, permission }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/oferte', { name, permission })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditOferta ({ state, commit }, ofertaId) {
  return new Promise((resolve, reject) => {
    if (ofertaId) {
      axiosInstance.get('/v1/oferte/' + ofertaId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta id'))
    }
  })
}

/* eslint-disable-next-line */
export function editOferta ({ state, commit }, { id, name, permission }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/oferte/' + id, { name, permission })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta id'))
    }
  })
}

export function deleteOferta ({ state, commit }, ofertaId) {
  return new Promise((resolve, reject) => {
    if (ofertaId) {
      axiosInstance.delete('/v1/oferte/' + ofertaId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta id'))
    }
  })
}
